import React, { useState } from "react";

const Review = ({ title, content, name, date, business }) => {
  const [expanded, setExpanded] = useState(false);
  const maxLength = 200; // Maximum character count before truncation

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  let star = (
    <svg
      className="w-[20px] h-[20px] text-primary  m-1"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 22 20"
    >
      <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
    </svg>
  );
    const isOversized  = content.length > maxLength
  const truncatedContent = content.slice(0, maxLength) + "...";
  const shouldShowReadMoreButton = content.length > maxLength;

  return (
    <div className="border text-black bg-white min-h-[200px] h-[90%] w-[220px] m-2">
      <div className="h-[10%]  pl-2.5 font-bold">{title}</div>
      <div className="w-full flex items-center pl-1  h-[10%] border-b border-black">
        {star}
        {star}
        {star}
        {star}
        {star}
      </div>
      <div className="min-h-[150px] h-[65%] px-3 pt-4 w-[220px] text-black">
     <p>
  {isOversized ? (expanded ? content : truncatedContent) : content}
</p>

        {shouldShowReadMoreButton && (
          <button className="font-bold underline " onClick={toggleExpanded}>
            {expanded? "Show Less" : "Read More"}
          </button>
        )}
      </div>
      <section className="border-t border-black pl-2.5 h-[15%] pb-1">
        <p className="font-bold">{name}</p>
        <p className="text-sm">{business}</p>
      </section>
    </div>
  );
};

export default Review;
